import { render, staticRenderFns } from "./AboutInstructor.vue?vue&type=template&id=7f767c8a&scoped=true&"
import script from "./AboutInstructor.vue?vue&type=script&lang=js&"
export * from "./AboutInstructor.vue?vue&type=script&lang=js&"
import style0 from "./AboutInstructor.vue?vue&type=style&index=0&id=7f767c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f767c8a",
  null
  
)

export default component.exports